import { builtEnvironment } from '@shared';
import { calculateTotalQuestions } from './utils';
import { assetCareFormDefinition } from './assetCareFormDef';
import { nationwideFormDefinition } from './nationwideFormDef';
import { nationwidePreApplicationFormDefinition } from './nationwidePreApplicationFormDef';

const carrierEmail = (email: string) =>
  builtEnvironment === 'prod' ? email : 'hello@joinwaterlily.com';

// =======================
// === UNDERWRITING FORM METADATA ===
// =======================
export const assetCareUnderwritingForm: PolicyFormMetadata = {
  formId: '7819c74f-7f58-4d67-a46b-23ff062c9c98',
  templateId: 'c58a8389-646d-432c-9632-93b9ed5e82f1',
  formType: 'pre-underwriting-form',
  title: 'Pre-Underwriting Form',
  carrier: 'OneAmerica',
  carrierEmail: carrierEmail('CSPUI@oneamerica.com'),
  product: 'AssetCare',
  totalQuestions: calculateTotalQuestions(assetCareFormDefinition),
  roleKeys: ['primaryInsured'],
};

export const nationwideUnderwritingForm: PolicyFormMetadata = {
  formId: '3cf5117d-6556-46fb-814f-988d1aba56ad',
  templateId:
    builtEnvironment === 'prod'
      ? 'e3016d69-16e1-4115-be96-19ee39971ed6'
      : 'b8c7134e-68f2-43a5-8b46-237116b88f60',
  formType: 'pre-underwriting-form',
  title: 'Pre-Underwriting Form',
  carrier: 'Nationwide',
  carrierEmail: carrierEmail('caremattersscreen@nationwide.com'),
  product: 'Care Matters II',
  totalQuestions: calculateTotalQuestions(nationwideFormDefinition),
  roleKeys: ['primaryInsured'],
};

// =======================
// === PRE-APPLICATION FORM METADATA ===
// =======================
const notApplicableProperties = {
  roleKeys: [],
  carrierEmail: '',
  templateId: '',
};

export const nationwidePreApplicationForm: PolicyFormMetadata = {
  formId: '476fa204-3191-4a1a-8b71-0bbf61064807',
  formType: 'application-form',
  title: 'Pre-Application Form',
  carrier: 'Nationwide',
  product: 'Care Matters II',
  totalQuestions: calculateTotalQuestions(nationwidePreApplicationFormDefinition),
  ...notApplicableProperties,
};
